// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const FindingStatusSchema = z.enum(['Unresolved','Resolved','FalsePositive','WontFix','InProgress','Retest'] as const);

export type FindingStatusType = `${z.infer<typeof FindingStatusSchema>}`

export default FindingStatusSchema;
